import { render, staticRenderFns } from "./icon-symbol.vue?vue&type=template&id=2ec7432a&scoped=true&"
import script from "./icon-symbol.vue?vue&type=script&lang=js&"
export * from "./icon-symbol.vue?vue&type=script&lang=js&"
import style0 from "./icon-symbol.vue?vue&type=style&index=0&id=2ec7432a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec7432a",
  null
  
)

export default component.exports